import { useEffect, useState } from "react";
import { DeleteCompanyDepartmentModalProps } from "./DeleteCompanyDepartmentModal";
import { deleteCompanyDepartmentAsync, getCompanyDepartmentByIdAsync } from "../../apiClient";
import { showDangerAlert } from "../../common";
import CompanyDepartment from "../../types/CompanyDepartment";

function useDeleteCompanyDepartmentModal(props: DeleteCompanyDepartmentModalProps) {
    const [department, setDepartment] = useState<CompanyDepartment>();
    const [isLoading, setIsLoading] = useState(true);
    const [deleteInProgress, setDeleteInProgress] = useState(false);

    useEffect(() => {
        async function fetchDataAsync() {
            setIsLoading(true);
            const result = await getCompanyDepartmentByIdAsync(props.departmentId);
            setIsLoading(false);

            if (result.failed) {
                console.error("Failed to fetch company department with id", props.departmentId, "Error:", result.error);
                showDangerAlert(props.resources.get("FetchCompanyDepartmentError") ?? "");
                props.onHide();
                return;
            }

            setDepartment(result.value);
        }

        if (props.show) {
            fetchDataAsync();
        }
    }, [props.departmentId, props.show]);

    async function handleDeleteCompanyDepartmentAsync() {
        setDeleteInProgress(true);
        const result = await deleteCompanyDepartmentAsync(props.departmentId);
        setDeleteInProgress(false);

        if (result.failed) {
            console.error("Failed to delete company department with id", props.departmentId, "Error:", result.error);
            showDangerAlert(props.resources.get("DeleteCompanyDepartmentError") ?? "");
            props.onHide();
            return;
        }

        props.onDepartmentDeleted();
        props.onHide();
    }

    return {
        department,
        isLoading,
        deleteInProgress,
        handleDeleteCompanyDepartmentAsync
    };
}

export default useDeleteCompanyDepartmentModal;
